import { TID } from "@/constants/testIds";
import { ShieldAlert } from "lucide-react";

export default function Disclaimer() {
    return (
        <div
            data-testid={TID.disclaimer}
            id="disclaimer"
            className="fixed bottom-0 inset-x-0 z-30 bg-cosmos-deep/85 backdrop-blur-xl border-t border-white/[0.06]"
        >
            <div className="max-w-screen-2xl mx-auto px-4 py-2 flex items-center justify-center gap-2 text-center text-[11px] text-white/55">
                <ShieldAlert className="w-3 h-3 text-gold shrink-0" />
                <span className="font-mono tracking-wide">
                    Reflective guidance only — not medical, legal or financial advice. Health entries
                    are check-up prompts, never diagnoses.
                </span>
            </div>
        </div>
    );
}
